export const AQA_ELEMENTS_MARKER_LIST = {
  entryPage: {
    ornInput: 'aqa-orn-input',
    ornTooltip: 'aqa-orn-tooltip',
    pcodeInput: 'aqa-pcode-input',
    pcodeTooltip: 'aqa-pcode-tooltip',
    viewOrderStatusButton: 'aqa-view-order-status-button',
  },
  summaryPage: {
    appointments: {
      appointmentInfo: 'aqa-appointment',
      siteContact: 'aqa-site-contact',
      appointmentsDescription: 'aqa-appointments-description',
    },
    deliveries: {
      accordion: 'aqa-accordion',
      deliveryLeftUs: 'aqa-delivery-left-us',
      deliveryOnTheWay: 'aqa-delivery-on-the-way',
      deliveryArrivedWithYou: 'aqa-delivery-arrived-with-you',
      trackingDetailTooltip: 'aqa-tracking-detail-tooltip',
    },
    orderSummary: {
      orderNumber: 'aqa-order-number',
      orderStatus: 'aqa-order-status',
      orderPlaced: 'aqa-order-placed',
      yourDeliveriesAndAppointments: {
        itemsSent: 'aqa-items-sent',
        appointmentScheduled: 'aqa-appointment-scheduled',
      },
      usefulLinks: {
        myAccount: 'aqa-my-account-link',
        helpAndSupport: 'aqa-help-and-support-link',
        downloadBtBussinessApp: 'aqa-download-bt-bussiness-app-link',
      },
    },
    serviceActivation: {
      'Business Broadband Access': 'aqa-bb-activation-date',
      'BT Cloud Voice Site Number': 'aqa-cv-activation-date',
      BBAndCVE: 'aqa-bb-cv-activation-date',
      nonHALO: 'aqa-nonhalo-activation-date',
    },
  },
};
